export class ApiError<TBody = unknown> extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly body: TBody,
    readonly response: Response,
  ) {
    super(message);
    this.name = "ApiError";
  }

  static async fromResponse(response: Response) {
    const body = await parseErrorBody(response.clone());

    return new ApiError(
      `API request failed with ${response.status}`,
      response.status,
      body,
      response,
    );
  }
}

async function parseErrorBody(response: Response): Promise<unknown> {
  if ([204, 205, 304].includes(response.status) || !response.body) {
    return null;
  }

  const contentType = response.headers.get("content-type") ?? "";

  if (contentType.includes("application/json")) {
    return response.json();
  }

  return response.text();
}
